export default __webpack_public_path__ + "static/media/rightArrow.36e61dbf.svg";